import Skeleton from "react-loading-skeleton";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

const SkeletonBanners = () => {
  const { isDesktop } = useBreakpoint();

  return isDesktop ? (
    <div className="SkeletonBanners">
      <div className="SkeletonBanners__title">
        <Skeleton width={566} height={48} />
      </div>
      <div className="SkeletonBanners__subtitle">
        <Skeleton width={530} height={48} />
      </div>
      <div className="SkeletonBanners__desc">
        <Skeleton width={312} height={25} />
      </div>
      <div className="SkeletonBanners__button">
        <Skeleton width={343} height={52} />
      </div>
    </div>
  ) : (
    <div className="SkeletonBanners__mobile">
      <Skeleton width="100%" height={150} />
    </div>
  );
};

export default SkeletonBanners;
